import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CartService } from '../../../../Services/cart.service';

@Component({
  selector: 'app-payment-success',
  imports: [RouterModule],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.css'
})
export class PaymentSuccessComponent {
  orderId: string | null = '';
  orderType: string | null = '';

  constructor(private route: ActivatedRoute, private cartService: CartService) { }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.orderId = params.get('OrderId');
      this.orderType = params.get('orderType');
    });

    if (this.orderId) {
      this.cartService.emptyCart();
    }
  }
}
